import { render, staticRenderFns } from "./PmauContas.vue?vue&type=template&id=3ed6d18e&"
import script from "./PmauContas.vue?vue&type=script&lang=js&"
export * from "./PmauContas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports